export const caseStudyItems = [
  {
    id: 'healthcare-cms',
    title: 'Healthcare CMS modernization',
    summary:
      'Expanded a healthcare-focused CMS with new modules while prioritizing performance, reliability, and maintainable delivery.',
    focusAreas: ['CMS feature delivery', 'Performance tuning', 'Maintainable architecture']
  },
  {
    id: 'ecommerce-apis',
    title: 'E-commerce API optimization',
    summary:
      'Optimized APIs and data retrieval flows that power e-commerce tooling, improving responsiveness across customer journeys.',
    focusAreas: ['API performance', 'Data access efficiency', 'Customer experience']
  },
  {
    id: 'react-csharp-integration',
    title: 'React and C# service integration',
    summary:
      'Aligned React.js interfaces with C# back-end services to deliver consistent enterprise workflows and stable releases.',
    focusAreas: ['Full stack delivery', 'Integration design', 'Release stability']
  }
];
